import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Button, CodeEventGroup, Match, MatchEvent } from '../../models';
import { MatchService } from '../../services';
import { DataConverter } from '../../converters';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'import-events-dialog',
  templateUrl: './import-events-dialog.html',
  styles: ['.mat-form-field { display: block }']
})
export class ImportEventsDialogComponent implements OnInit {
  @ViewChild('stepper') stepper;

  isLinear = true;
  selectSourceFormGroup: FormGroup;
  events: CodeEventGroup[] = [];
  inputText: string;

  eventCount: number;

  public readonly converters: string[] = [];

  constructor(
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<ImportEventsDialogComponent>,
    public matchService: MatchService,
    private dataConverter: DataConverter,
    @Inject(MAT_DIALOG_DATA) public match: Match
  ) {
    this.converters = dataConverter.converters;
  }

  ngOnInit(): void {
    this.selectSourceFormGroup = this._fb.group({
      source: ['', Validators.required]
    });

    // this.inputFileFormGroup = this._fb.group({
    //   inputText: ["", Validators.required]
    // });
  }

  openFile(event) {
    const input = event.target;
    for (let index = 0; index < input.files.length; index++) {
      const reader = new FileReader();
      reader.onload = () => {
        // this 'text' is the content of the file
        const text = reader.result;
        this.inputText = text;
      };
      reader.readAsText(input.files[index]);
    }
  }

  process() {
    const selectedConverter = this.selectSourceFormGroup.controls.source.value;
    // const inputText = this.inputFileFormGroup.controls.inputText.value;
    const converter = this.dataConverter.getConverter(selectedConverter);
    const match = converter.convert(this.inputText);

    console.log(match);

    if (match !== undefined) {
      this.events = match.events;
    }

    this.stepper.selectedIndex = 1;
  }

  onImportClick(): void {
    this.match.events = this.events;
    this.match.isCurrentPublished = false;
    console.info('[ImportEventsDialog] importing:', this.events);
    this.matchService.update(this.match).subscribe(e => {
      this.dialogRef.close(e);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
